import TextBodyMedium from 'components/TextBodyBig'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'

function Title ({ value, style, url }) {
  return (
    <TextBodyMedium
      style={{
        marginTop: STYLES_MARGIN.SMALL,
        ...(
          style ||
          {}
        )
      }}
    >
      <Link to={url}>
        {value}
      </Link>
    </TextBodyMedium>
  )
}

Title.propTypes = {
  value: PropTypes.string.isRequired,
  style: PropTypes.object,
  url: PropTypes.string.isRequired
}

export default Title
